import { render, staticRenderFns } from "./UploadFileMulter.vue?vue&type=template&id=2c24443f&scoped=true"
import script from "./UploadFileMulter.vue?vue&type=script&lang=js"
export * from "./UploadFileMulter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c24443f",
  null
  
)

export default component.exports